import { ethers } from "ethers";
import { useContext, useEffect, useState } from "react";
import { alchemy } from "src/apis/alchemyToken";
import { IS_DEV } from "src/constants";
import { Web3Context } from "src/contexts";
import { ERC721ABI } from "src/contracts/external_contracts";

const CRYPTOPUNKS = "0xb47e3cd837ddf8e4c57f05d70ab865de6e193bbb";
const BAYC = "0xbc4ca0eda7647a8ab7c2061c2e118a18a936f13d";

function useGetOwner(contractAddress, tokenId) {
  const [owner, setOwner] = useState("");
  const { injectedProvider } = useContext(Web3Context);

  useEffect(() => {
    // infura provider
    // const provider =
    const network = IS_DEV
      ? process.env.REACT_APP_DEV_NETWORK_NAME
      : process.env.REACT_APP_PROD_NETWORK_NAME;
    const provider = new ethers.providers.InfuraProvider(
      network,
      process.env.INFURA_ID
    );

    console.log({ provider });

    const nftContract = new ethers.Contract(
      contractAddress,
      ERC721ABI,
      provider
    );

    let owner;
    async function getOwner() {
      try {
        switch (contractAddress) {
          case BAYC:
            owner = await nftContract.ownerOf(tokenId);
            break;

          case CRYPTOPUNKS:
            owner = await nftContract.punkIndexToAddress(tokenId);
            break;

          default:
            owner = await nftContract.ownerOf(tokenId);
            break;
        }

        setOwner(owner);
      } catch (error) {
        // get owner
        const { owners } = await alchemy.nft.getOwnersForNft(
          contractAddress,
          tokenId
        );
        setOwner(owners[0]);

        console.log(error);
      }
    }

    if (contractAddress && tokenId && injectedProvider) {
      getOwner();
    }
  }, [tokenId, contractAddress, injectedProvider]);

  return { owner };
}

export default useGetOwner;
